
import { defineComponent, PropType } from 'vue'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import OpenDialogField from '@/components/_shared/open-dialog-field.vue'
import AgreementsBillingInfoEditContactDataDialog from '@/components/agreements/dialogs/billing-info/edit-contact-data.vue'
import { ContactData } from '@/modules/billing-templates'

export default defineComponent({
    name: 'agreements-billing-info-open-dialog-field-contact-data',
    components: {
        // OpenDialogField
    },
    props: {
        value: {
            type: Object as PropType<ContactData>,
            required: true
        },
        agreementId: {
            type: String,
            required: true
        },
        billingInfoId: {
            type: String,
            required: true
        },
        updateContactDataCallback: {
            type: Function as PropType<(t: ContactData) => void>,
            required: true
        }
    },
    setup (props) {
        const $q = useQuasar()

        const onValueUpdated = (newValue: ContactData) => {
            props.updateContactDataCallback(newValue)
        }

        function onChangeContactData () {
            $q.dialog({
                component: AgreementsBillingInfoEditContactDataDialog,
                componentProps: {
                    contactData: { ...props.value },
                    agreementId: props.agreementId,
                    billingInfoId: props.billingInfoId,
                    updateCallback: onValueUpdated
                }
            })
        }
        return {
            onChangeContactData
        }
    }
})
